import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

import HomePage          from '../pages/HomePage';
import LoginPage         from '../pages/LoginPage';
import RegisterPage      from '../pages/RegisterPage';
import RequestPage       from '../pages/RequestPage';
import StockPage         from '../pages/StockPage';
import SuppliersPage     from '../pages/SuppliersPage';
import HowItWorksPage    from '../pages/HowItWorksPage';
import CategoriesPage    from '../pages/CategoriesPage';
import PaymentResultPage from '../pages/PaymentResultPage';
import LegalPage         from '../pages/legal/LegalPage';
import CookieBanner      from '../components/CookieBanner';
import DashboardPage     from '../pages/dashboard/DashboardPage';
import CustomerDashboard from '../pages/dashboard/CustomerDashboard';
import SupplierDashboard from '../pages/dashboard/SupplierDashboard';
import AdminDashboard    from '../pages/dashboard/AdminDashboard';

// Redirect to login if not authenticated
const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
};

// Redirect away from login/register if already logged in
const GuestRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return children;
  if (user.role === 'admin')    return <Navigate to="/dashboard/admin" />;
  if (user.role === 'supplier') return <Navigate to="/dashboard/supplier" />;
  return <Navigate to="/dashboard/customer" />;
};

const AppRoutes = () => (
  <Router>
    <Routes>
      {/* Public */}
      <Route path="/"           element={<HomePage />}      />
      <Route path="/request"    element={<RequestPage />}   />
      <Route path="/stock"      element={<StockPage />}     />
      <Route path="/kategoriler" element={<CategoriesPage />} />
      <Route path="/suppliers"  element={<SuppliersPage />} />

      {/* Guest only */}
      <Route path="/login"    element={<GuestRoute><LoginPage /></GuestRoute>}    />
      <Route path="/register" element={<GuestRoute><RegisterPage /></GuestRoute>} />

      {/* Protected dashboards */}
      <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
      <Route path="/dashboard/customer" element={<PrivateRoute><CustomerDashboard /></PrivateRoute>} />
      <Route path="/dashboard/supplier" element={<PrivateRoute><SupplierDashboard /></PrivateRoute>} />
      <Route path="/dashboard/admin"    element={<PrivateRoute><AdminDashboard /></PrivateRoute>}    />

      <Route path="/how-it-works" element={<HowItWorksPage />} />

      {/* Payment result (iyzico redirects here after Checkout Form) */}
      <Route path="/odeme/sonuc" element={<PaymentResultPage />} />

      {/* Legal documents */}
      <Route path="/yasal/:slug" element={<LegalPage />} />

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
    <CookieBanner />
  </Router>
);

export default AppRoutes;